<div class="view-contect" fxLayout="column">
  <span><b>Columns</b></span>
  <div
    cdkDropList
    cdkDropListLockAxis="y"
    (cdkDropListDropped)="onValueListItemDropped($event)"
  >
    @for (column of columns; track column) {
      <div cdkDrag [cdkDragDisabled]="!canManageColumns">
        <mat-card
          appearance="outlined"
          class="column-card"
          [class.disabled]="!canManageColumns"
        >
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center">
              <ng-content select="[slot=drag-handle]"></ng-content>
              <mat-icon slot="drag-handle" cdkDragHandle
                >drag_indicator</mat-icon
              >
              <span>{{ column.displayName }}</span>
            </div>
            <button
              mat-icon-button
              color="primary"
              [disabled]="columns.length < 2 || !canManageColumns"
              (click)="onDeleteColumn(column)"
              aria-label="Delete column"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-card>
      </div>
    }
  </div>
  <item-picker
    [disabled]="!canManageColumns || itemPickerList.length === 0"
    [data]="itemPickerList"
    placeholder="Add New Column"
    type="button"
    (select)="onAddColumn($event)"
  ></item-picker>
</div>
